import script from "./TaskType.vue?vue&type=script&setup=true&lang=js"
export * from "./TaskType.vue?vue&type=script&setup=true&lang=js"

import "./TaskType.vue?vue&type=style&index=0&id=4c6a76be&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4c6a76be"]])

export default __exports__